export const GET_ERRORS = "GET_ERRORS";
export const SET_CURRENT_ADMIN = "SET_CURRENT_ADMIN";
export const SET_CURRENT_PLAYERS = "SET_CURRENT_PLAYERS";
export const SET_REGISTERED_PLAYERS = "SET_REGISTERED_PLAYERS";
export const SET_INLINE_PLAYERS = "SET_INLINE_PLAYERS";
export const SET_LEADERBOARD = "SET_LEADERBOARD";